import {cloneElement} from 'react'
import {css} from '@emotion/react'
import {Button} from 'antd'
import {PlusOutlined} from '@ant-design/icons'
import {FileList} from '@/components/File/index.mjs'
import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import {chooseFiles} from '@/script/file.mjs'
import {useReadOnly} from './ReadOnly.mjs'

const cssButtonChoose = css({
    height: 58,
    backgroundColor: 'rgb(243, 244, 246)',
    border: 'none',
    borderRadius: 12,

    ':hover': {
        backgroundColor: 'rgb(243, 244, 246)',
        boxShadow: '0px 0px 0px .5px #dce0e9,0px 4px 8px 0px rgba(144,150,174,.25)',
    },
})

const ButtonChoose = (props) => (
    <Button
        css={cssButtonChoose}
        title="选择文件"
        {...props}
    >
        <PlusOutlined />
    </Button>
)

const cssFilePicker = css({
})

const defaultValue = []

export default function FilePicker({
    buttonChoose = <ButtonChoose />,
    disabled,
    limit = 10,
    // TODO
    maxFileSize = 50000, // KB
    readOnly,
    startIn,
    types,
    value = defaultValue,
    onChange,
    ...props
}) {
    const openModal = useOpenModal()
    const gReadOnly = useReadOnly()

    const onClick = async e => {
        e.stopPropagation()

        const files = await chooseFiles({
            multiple: true,
            types,
            startIn,
        })

        const digest = f => `${f.name}${f.size}${f.lastModified}`
        const hashSet = new Set(value.map(digest))
        const newFiles = files.filter(f => ! hashSet.has(digest(f)))
        const newValue = [...value, ...newFiles]

        if (limit < newValue.length) {
            await openModal(
                <Alert type="error">
                    超出了最大文件数：{limit}
                </Alert>
            )

            return
        }
        else {
            onChange(newValue)
        }
    }

    const btnChoose = (readOnly || gReadOnly || limit <= value.length) ?
        null
        :
        cloneElement(buttonChoose, {disabled, onClick})

    return (
        <div
            css={cssFilePicker}
            {...props}
        >
            <FileList
                before={btnChoose}
                files={value}
                onChange={disabled || readOnly ? null : onChange}
            />
        </div>
    )
}
